import KPIDTO from 'models/dto/kpi/kpiDTO';
import TaskTypeDTO from 'models/dto/tasks/taskTypeDTO';

export class FormStructureMutationDTO {
  taskTypeFamilyId: number;

  expectedTaskTypeId: number;

  expectedHeadRowVersion?: string;

  mutationId: string;

  editSessionId: string;

  form: TaskTypeDTO;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.expectedTaskTypeId = 0;
    this.mutationId = '';
    this.editSessionId = '';
    this.form = new TaskTypeDTO();
  }
}

export class FormStructureMutationResultDTO {
  taskType: TaskTypeDTO;

  isNoOp: boolean;

  createdVersion: boolean;

  constructor() {
    this.taskType = new TaskTypeDTO();
    this.isNoOp = false;
    this.createdVersion = false;
  }
}

export class FormEditSessionDiscardMutationDTO {
  taskTypeFamilyId: number;

  expectedTaskTypeId: number;

  expectedHeadRowVersion?: string;

  baselineDefinitionHash: string;

  expectedCurrentDefinitionHash: string;

  mutationId: string;

  editSessionId: string;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.expectedTaskTypeId = 0;
    this.baselineDefinitionHash = '';
    this.expectedCurrentDefinitionHash = '';
    this.mutationId = '';
    this.editSessionId = '';
  }
}

export class FormKPIPlacementMutationDTO {
  kpi: KPIDTO;

  form: FormStructureMutationDTO;

  newFieldIndex: number;

  constructor() {
    this.kpi = new KPIDTO();
    this.form = new FormStructureMutationDTO();
    this.newFieldIndex = -1;
  }
}

export class FormKPIPlacementResultDTO {
  kpi: KPIDTO;

  form: FormStructureMutationResultDTO;

  constructor() {
    this.kpi = new KPIDTO();
    this.form = new FormStructureMutationResultDTO();
  }
}

export class FormVersionAmendmentDTO {
  formVersionEventId: number;

  eventType: number;

  actorKind: number;

  date: string;

  changedById?: string;

  changedBy?: string;

  triggeredById?: string;

  triggeredBy?: string;

  beforeHash?: string;

  afterHash?: string;

  changedProperties: string[];

  hasSnapshotAnchor: boolean;

  constructor() {
    this.formVersionEventId = 0;
    this.eventType = 0;
    this.actorKind = 0;
    this.date = '';
    this.changedProperties = [];
    this.hasSnapshotAnchor = false;
  }
}

export class FormVersionHistoryDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  version: number;

  name?: string;

  date: string;

  changedById?: string;

  changedBy?: string;

  numberOfFields: number;

  isCurrent: boolean;

  isUsed: boolean;

  taskCount: number;

  amendments: FormVersionAmendmentDTO[];

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.version = 0;
    this.date = '';
    this.numberOfFields = 0;
    this.isCurrent = false;
    this.isUsed = false;
    this.taskCount = 0;
    this.amendments = [];
  }
}

export class FormVersionFieldDiffDTO {
  fieldKey: string;

  fieldId?: number;

  status: 'Added' | 'Deleted' | 'Changed';

  changedProperties: string[];

  constructor() {
    this.fieldKey = '';
    this.status = 'Changed';
    this.changedProperties = [];
  }
}

export class FormVersionDiffDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  compareTaskTypeId: number;

  fields: FormVersionFieldDiffDTO[];

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.compareTaskTypeId = 0;
    this.fields = [];
  }
}

export class FormArchiveMutationDTO {
  taskTypeFamilyId: number;

  detachProducers: boolean;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.detachProducers = false;
  }
}

export class FormArchiveProducerDTO {
  taskId: number;

  name?: string;

  taskType: number;

  constructor() {
    this.taskId = 0;
    this.taskType = 0;
  }
}

export class FormArchivePreviewDTO {
  taskTypeFamilyId: number;

  producers: FormArchiveProducerDTO[];

  inaccessibleProducerCount: number;

  blockingConcreteTaskCount: number;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.producers = [];
    this.inaccessibleProducerCount = 0;
    this.blockingConcreteTaskCount = 0;
  }
}

export class FormUpgradeMutationDTO {
  taskTypeFamilyId: number;

  taskMasterId?: number;

  constructor() {
    this.taskTypeFamilyId = 0;
  }
}

export class FormUpgradeTaskDTO {
  taskId: number;

  name?: string;

  constructor() {
    this.taskId = 0;
  }
}

export class FormUpgradePreviewDTO {
  taskTypeFamilyId: number;

  taskMasterId?: number;

  taskTypeId: number;

  version: number;

  name?: string;

  tasks: FormUpgradeTaskDTO[];

  upgradableCount: number;

  answeredCount: number;

  closedCount: number;

  inaccessibleCount: number;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.version = 0;
    this.tasks = [];
    this.upgradableCount = 0;
    this.answeredCount = 0;
    this.closedCount = 0;
    this.inaccessibleCount = 0;
  }
}

export class FormUpgradeResultDTO {
  taskTypeFamilyId: number;

  taskMasterId?: number;

  taskTypeId: number;

  version: number;

  name?: string;

  upgraded: FormUpgradeTaskDTO[];

  upgradedCount: number;

  answeredCount: number;

  closedCount: number;

  inaccessibleCount: number;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.version = 0;
    this.upgraded = [];
    this.upgradedCount = 0;
    this.answeredCount = 0;
    this.closedCount = 0;
    this.inaccessibleCount = 0;
  }
}

export class FormPurgeMutationDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  mutationId: string;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.mutationId = '';
  }
}

export class FormPurgePreviewDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  canPurge: boolean;

  blockers: string[];

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.canPurge = false;
    this.blockers = [];
  }
}

export class FormTextCorrectionMutationDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  fieldKey?: string;

  languageId: number;

  name: string;

  description?: string;

  tabName?: string;

  instruction?: string;

  expectedResult?: string;

  expectedTaskTypeRowVersion?: string;

  expectedImpactHash?: string;

  mutationId: string;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.languageId = 0;
    this.name = '';
    this.mutationId = '';
  }
}

export class TextCorrectionFormVersionImpactDTO {
  taskTypeFamilyId: number;

  taskTypeId: number;

  version: number;

  name?: string;

  isCurrent: boolean;

  isArchived: boolean;

  taskCount: number;

  constructor() {
    this.taskTypeFamilyId = 0;
    this.taskTypeId = 0;
    this.version = 0;
    this.isCurrent = false;
    this.isArchived = false;
    this.taskCount = 0;
  }
}

export class TextCorrectionTaskStateImpactDTO {
  taskStateId: number;

  taskCount: number;

  constructor() {
    this.taskStateId = 0;
    this.taskCount = 0;
  }
}

export class TextCorrectionImpactPreviewDTO {
  impactHash: string;

  affectedFamilyCount: number;

  affectedTaskCount: number;

  affectedKPIDataCount: number;

  draftReportCount: number;

  publishedReportCount: number;

  formVersions: TextCorrectionFormVersionImpactDTO[];

  taskStates: TextCorrectionTaskStateImpactDTO[];

  constructor() {
    this.impactHash = '';
    this.affectedFamilyCount = 0;
    this.affectedTaskCount = 0;
    this.affectedKPIDataCount = 0;
    this.draftReportCount = 0;
    this.publishedReportCount = 0;
    this.formVersions = [];
    this.taskStates = [];
  }
}
